import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface SumoImage {
  id: string;
  image_url: string;
  alt_text?: string;
  is_primary: boolean;
  display_order: number;
}

export const useSumoImages = (sumoId: string) => {
  const [images, setImages] = useState<SumoImage[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadImages = async () => {
    if (!sumoId) {
      setImages([]);
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      const { data, error } = await supabase
        .from('sumo_images')
        .select('*')
        .eq('sumo_id', sumoId)
        .order('is_primary', { ascending: false })
        .order('display_order', { ascending: true });

      if (error) throw error;

      setImages(data || []);
      setError(null);
    } catch (err) {
      console.error('Erreur lors du chargement des images sumo:', err);
      setError(err instanceof Error ? err.message : 'Erreur inconnue');
      setImages([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadImages();
  }, [sumoId]);

  const refreshImages = () => {
    loadImages();
  };

  // Return image URLs for compatibility with existing components
  const imageUrls = images.map(img => img.image_url);

  return {
    images,
    imageUrls,
    isLoading,
    error,
    refreshImages
  };
};